<div class="body-content-overlay"></div>
<!-- Main chat area -->
<section class="chat-app-window">
  <!-- To load Conversation -->
  <div class="start-chat-area" [ngClass]="{ 'd-none': activeChat === true }">
    <div class="mb-1 start-chat-icon">
      <i data-feather="message-square"></i>
    </div>
    <h4 class="sidebar-toggle start-chat-text" (click)="toggleSidebar('chat-sidebar')">{{ "START_CONVERSATION" | translate }}</h4>
  </div>
  <!--/ To load Conversation -->

  <!-- Active Chat -->
  <div class="active-chat" [ngClass]="{ 'd-none': activeChat !== true }" *ngIf="activeChat === true">
    <!-- Chat Header -->
    <div class="chat-navbar">
      <header class="chat-header">
        <div class="d-flex align-items-center">
          <button class="btn sidebar-toggle d-block d-lg-none mr-1 p-0" (click)="toggleSidebar('chat-sidebar')">
            <i data-feather="menu" class="font-medium-5"></i>
          </button>
          <div class="avatar avatar-border bg-transparent m-0 mr-1 p-0">
            <img class="round" [src]="chatUser.avatar" alt="avatar" height="36" width="36" />
            <span
              [ngClass]="{
                'avatar-status-offline': chatUser.status == 'offline',
                'avatar-status-online': chatUser.status == 'online',
                'avatar-status-busy': chatUser.status == 'busy',
                'avatar-status-away': chatUser.status == 'away'
              }"
            ></span>
          </div>
          <a class="mb-0 font-medium-1" [routerLink]="['/dashboard/user/profile/', chatUser.hash]">{{ chatUser.complete_name }}</a>
        </div>
      </header>
    </div>
    <!--/ Chat Header -->

    <!-- User Chat messages -->
    <div class="user-chats" [perfectScrollbar] #scrollMe [scrollTop]="scrolltop">
      <div class="chats">
        <div class="chat" *ngFor="let chatSender of chats.messages" [ngClass]="{ 'chat-left': chatSender.sender_hash !== userProfile.hash }">
          <div class="chat-avatar">
            <span class="avatar box-shadow-1 cursor-pointer">
              <img class="round" *ngIf="chatSender.sender_hash !== userProfile.hash; else alternateAvatar" [src]="chatUser.avatar" alt="avatar" height="36" width="36" />
              <ng-template #alternateAvatar>
                <img class="round" [src]="userProfile.avatar" alt="avatar" height="36" width="36" />
              </ng-template>
            </span>
          </div>
          <div class="chat-body">
            <div class="chat-content">
              <small class="mr-075 font-small-1" *ngIf="chatSender.sender_hash !== userProfile.hash">{{ chatSender.create_date | date: "H:mm" }}</small>
              <p>{{ chatSender.message }}</p>
              <small class="ml-075 font-small-1" *ngIf="chatSender.sender_hash == userProfile.hash">{{ chatSender.create_date | date: "H:mm" }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- User Chat messages -->

    <!-- Submit Chat form -->
    <form class="chat-app-form" action="javascript:void(0);">
      <div class="input-group input-group-merge mr-1 form-send-message">
        <input type="text" class="form-control message" placeholder="{{ 'WRITE_A_MESSAGE' | translate }}" [(ngModel)]="chatMessage" name="chat-message" (keydown.enter)="updateChat(chatId)" />
      </div>
      <button type="button" class="btn btn-primary send" (click)="updateChat(chatId)" rippleEffect>
        <i data-feather="send" class="d-lg-none"></i>
        <span class="d-none d-lg-block">{{ "SEND" | translate }}</span>
      </button>
    </form>
    <!--/ Submit Chat form -->
  </div>
  <!--/ Active Chat -->
</section>
<!--/ Main chat area -->
